import { useCallback } from 'react';
import { IChatMessage } from 'src/@types/chat';
import { setPinned } from 'src/redux/slices/chat';
import { useDispatch } from 'src/redux/store';

export const usePinMessage = ({ channelId }: { channelId: string }) => {
  const dispatch = useDispatch();

  const pinMessage = useCallback(
    async (message: IChatMessage) => {
      await dispatch(
        setPinned({
          id: message._id,
          channel: channelId,
          pinned: !message.pinned,
        }),
      );
    },
    [channelId, dispatch],
  );

  return { pinMessage };
};
